<template>
  <div class="invoice-operation">
    <div
      v-if="hasOperations"
      class="operation-buttons"
    >
      <div
        v-for="item in rowData.invoice_list"
        :key="item.id"
        class="operation-group"
      >
        <span v-if="!item.operate.length">-</span>
        <template v-else>
          <a
            v-for="(status, index) in item.operate"
            :key="status"
            class="operation-link"
            @click="handleOperateClick(status, item)"
          >
            {{ item.operate_str[index] }}
          </a>
        </template>
      </div>
    </div>
    <span v-else>-</span>
  </div>
</template>

<script>
export default {
  name: 'InvoiceOperation',
  props: {
    // 当前行数据
    rowData: {
      type: [Object, Array],
      required: true,
      default: () => ({})
    }
  },
  computed: {
    // 判断是否有可操作项
    hasOperations() {
      const { invoice_list } = this.rowData
      if (!invoice_list || invoice_list.length === 0) return false
      return invoice_list.some(item => item.operate && item.operate.length > 0)
    },
  },
  methods: {
    // 处理操作按钮点击事件
    handleOperateClick(status, item) {
      // 向父组件发送操作事件
      this.$emit('operate', {
        status,
        invoiceItem: item,
        rowData: this.rowData,
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-operation {
  .operation-buttons {
    .operation-group {
      display: flex;
    }

    .operation-link {
      color: #1890ff;
      cursor: pointer;
      text-decoration: none;
      font-size: 14px;
      
      &:hover {
        color: #40a9ff;
        text-decoration: underline;
      }
      
      & + .operation-link {
        margin-left: 8px;
      }
    }
  }
}
</style>
